import "./DashboardEmptyState.styles.scss";
import React from "react";
import { Link } from "components";
import BalloonTwo from "assets/images/balloon-2.png";
import { useTranslation } from "react-i18next";
import {
  getPatientWord,
  getPatientWordCapitalized,
} from "utils/hooks/organizations/useOrganizationSettings";

const DashboardEmptyState = ({ user, orgSettings }) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="dashboard-empty-state">
      <h2>{t("dashboard.calm_greeting", { userName: user.firstName })} 👋</h2>
      <h3>{t("dashboard.onboarding_header")}</h3>
      <p>
        {t("dashboard.empty_state_paragraph", {
          patientWord: getPatientWord(orgSettings),
        })}
      </p>
      <p>
        <Link to={"/patients"}>
          {t("patients.add_patient_button", {
            patientWordCapitalized: getPatientWordCapitalized(orgSettings),
          })}
        </Link>{" "}
        {t("dashboard.onboarding_step_2_incomplete", {
          patientWord: getPatientWord(orgSettings),
        })}
      </p>
      <div className="dashboard-empty-state__image-holder">
        <img
          className="dashboard-empty-state__image"
          src={BalloonTwo}
          alt="hot air balloon with person waving"
        />
      </div>
    </div>
  );
};

export default DashboardEmptyState;
